import { render, staticRenderFns } from "./TransactionNewEditDialog.vue?vue&type=template&id=031068e0&"
import script from "./TransactionNewEditDialog.vue?vue&type=script&lang=js&"
export * from "./TransactionNewEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./TransactionNewEditDialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
